import React from 'react';
import {DashboardPage} from '../../components/Dashboard';
import {useNavigate} from 'react-router-dom';
import {route} from '../../constants/routes';
import {useDeleteTicketsGroup, useGetTicketGroupsTable} from '../../hooks/tickets';

export const Dashboard = () => {
  const {
    tickets,
    refetch,
    metrics,
    loading,
    searchTickets,
    pagination,
    metricsLoading,
    isSearching,
    currentTab,
    changeTab,
  } = useGetTicketGroupsTable();
  const navigate = useNavigate();
  const canAddEdit = true;
  const goEdit = (id: string) => canAddEdit && navigate(route.editTicketGroup.get({id}));
  const {onDelete} = useDeleteTicketsGroup(refetch);

  return (
    <DashboardPage
      goEdit={goEdit}
      onDelete={onDelete}
      tickets={tickets}
      metrics={metrics}
      canAddEdit={canAddEdit}
      loading={loading}
      searchTickets={searchTickets}
      pagination={pagination}
      metricsLoading={metricsLoading}
      isSearching={isSearching}
      changeTab={changeTab}
      currentTab={currentTab}
    />
  );
};
